/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Theme } from "./Theme";
import { ThemeFromJSON, ThemeFromJSONTyped, ThemeToJSON, ThemeToJSONTyped } from "./Theme";
import type { PatchedProjectArea } from "./PatchedProjectArea";
import {
  PatchedProjectAreaFromJSON,
  PatchedProjectAreaFromJSONTyped,
  PatchedProjectAreaToJSON,
  PatchedProjectAreaToJSONTyped,
} from "./PatchedProjectArea";

/**
 *
 * @export
 * @interface PatchedProject
 */
export interface PatchedProject {
  /**
   *
   * @type {string}
   * @memberof PatchedProject
   */
  readonly url?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedProject
   */
  slug?: string | null;
  /**
   *
   * @type {string}
   * @memberof PatchedProject
   */
  name?: string;
  /**
   *
   * @type {Date}
   * @memberof PatchedProject
   */
  readonly createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof PatchedProject
   */
  readonly updatedAt?: Date;
  /**
   *
   * @type {PatchedProjectArea}
   * @memberof PatchedProject
   */
  area?: PatchedProjectArea | null;
  /**
   *
   * @type {string}
   * @memberof PatchedProject
   */
  readonly organisationName?: string;
  /**
   * Extra key/values like address that can be stored by the UI
   * @type {any}
   * @memberof PatchedProject
   */
  extraValues?: any | null;
  /**
   *
   * @type {Array<Theme>}
   * @memberof PatchedProject
   */
  readonly themes?: Array<Theme>;
}

/**
 * Check if a given object implements the PatchedProject interface.
 */
export function instanceOfPatchedProject(value: object): value is PatchedProject {
  return true;
}

export function PatchedProjectFromJSON(json: any): PatchedProject {
  return PatchedProjectFromJSONTyped(json, false);
}

export function PatchedProjectFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedProject {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    slug: json["slug"] == null ? undefined : json["slug"],
    name: json["name"] == null ? undefined : json["name"],
    createdAt: json["created_at"] == null ? undefined : new Date(json["created_at"]),
    updatedAt: json["updated_at"] == null ? undefined : new Date(json["updated_at"]),
    area: json["area"] == null ? undefined : PatchedProjectAreaFromJSON(json["area"]),
    organisationName: json["organisation_name"] == null ? undefined : json["organisation_name"],
    extraValues: json["extra_values"] == null ? undefined : json["extra_values"],
    themes: json["themes"] == null ? undefined : (json["themes"] as Array<any>).map(ThemeFromJSON),
  };
}

export function PatchedProjectToJSON(json: any): PatchedProject {
  return PatchedProjectToJSONTyped(json, false);
}

export function PatchedProjectToJSONTyped(
  value?: Omit<
    PatchedProject,
    "url" | "created_at" | "updated_at" | "organisation_name" | "themes"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    slug: value["slug"],
    name: value["name"],
    area: PatchedProjectAreaToJSON(value["area"]),
    extra_values: value["extraValues"],
  };
}
